"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftMetadataProvider = exports.useNftAPI = exports.useNft = exports.useNftCollectionMetadata = exports.useNftMetadata = void 0;
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const react_1 = __importStar(require("react"));
const helpers_1 = require("../helpers");
const bridge_1 = require("../../bridge");
const logic_1 = require("./logic");
const NftMetadataContext = (0, react_1.createContext)({
    cache: {},
    loadNFTMetadata: () => Promise.resolve(),
    loadCollectionMetadata: () => Promise.resolve(),
    clearCache: () => { },
});
function useNftMetadata(contract, tokenId, currencyId) {
    const { cache, loadNFTMetadata } = (0, react_1.useContext)(NftMetadataContext);
    const key = contract && tokenId && currencyId ? (0, helpers_1.getNftKey)(contract, tokenId, currencyId) : "";
    const cachedData = cache[key];
    (0, react_1.useEffect)(() => {
        if (!contract || !tokenId || !currencyId)
            return;
        if (!cachedData || (0, logic_1.isOutdated)(cachedData)) {
            loadNFTMetadata(contract, tokenId, currencyId);
        }
    }, [contract, tokenId, cachedData, loadNFTMetadata, currencyId]);
    if (cachedData) {
        return cachedData;
    }
    else {
        return {
            status: "queued",
        };
    }
}
exports.useNftMetadata = useNftMetadata;
function useNftCollectionMetadata(contract, currencyId) {
    const { cache, loadCollectionMetadata } = (0, react_1.useContext)(NftMetadataContext);
    const key = contract && currencyId ? (0, helpers_1.getNftCollectionKey)(contract, currencyId) : "";
    const cachedData = cache[key];
    (0, react_1.useEffect)(() => {
        if (!contract || !currencyId)
            return;
        if (!cachedData || (0, logic_1.isOutdated)(cachedData)) {
            loadCollectionMetadata(contract, currencyId);
        }
    }, [contract, cachedData, currencyId, loadCollectionMetadata]);
    if (cachedData) {
        return cachedData;
    }
    else {
        return {
            status: "queued",
        };
    }
}
exports.useNftCollectionMetadata = useNftCollectionMetadata;
function useNft(protoNft) {
    const data = useNftMetadata(protoNft.contract, protoNft.tokenId, protoNft.currencyId);
    const { status } = data;
    const metadata = (0, react_1.useMemo)(() => (status === "loaded" ? data.metadata : null), [data, status]);
    const nft = (0, react_1.useMemo)(() => (status === "loaded" && metadata ? Object.assign(Object.assign({}, protoNft), { metadata }) : null), [protoNft, metadata, status]);
    return status !== "loaded"
        ? { status }
        : {
            status,
            nft: nft,
        };
}
exports.useNft = useNft;
function useNftAPI() {
    const { clearCache, loadNFTMetadata, loadCollectionMetadata } = (0, react_1.useContext)(NftMetadataContext);
    return {
        clearCache,
        loadNFTMetadata,
        loadCollectionMetadata,
    };
}
exports.useNftAPI = useNftAPI;
function NftMetadataProvider({ children }) {
    const [state, setState] = (0, react_1.useState)({
        cache: {},
    });
    const api = (0, react_1.useMemo)(() => ({
        loadNFTMetadata: (contract, tokenId, currencyId) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const key = (0, helpers_1.getNftKey)(contract, tokenId, currencyId);
            const currency = (0, cryptoassets_1.getCryptoCurrencyById)(currencyId);
            const currencyBridge = (0, bridge_1.getCurrencyBridge)(currency);
            if (!((_a = currencyBridge.nftResolvers) === null || _a === void 0 ? void 0 : _a.nftMetadata)) {
                throw new Error("Currency doesn't support NFT metadata");
            }
            setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: Object.assign(Object.assign({}, oldState.cache), { [key]: {
                        status: "loading",
                    } }) })));
            try {
                const { status, result } = yield currencyBridge.nftResolvers.nftMetadata({
                    contract,
                    tokenId,
                    currencyId: currency.id,
                });
                switch (status) {
                    case 500:
                        throw new Error("NFT Metadata Provider failed");
                    case 404:
                        setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: Object.assign(Object.assign({}, oldState.cache), { [key]: {
                                    status: "nodata",
                                    metadata: null,
                                    updatedAt: Date.now(),
                                } }) })));
                        break;
                    case 200:
                        setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: Object.assign(Object.assign({}, oldState.cache), { [key]: {
                                    status: "loaded",
                                    metadata: result,
                                    updatedAt: Date.now(),
                                } }) })));
                        break;
                    default:
                        break;
                }
            }
            catch (_error) {
                // This shenanigan is here to avoid an Hermes bug https://github.com/pmndrs/zustand/discussions/1269
                const error = new Error(_error ? _error.message : "Unknown Error");
                setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: Object.assign(Object.assign({}, oldState.cache), { [key]: {
                            status: "error",
                            error,
                            updatedAt: Date.now(),
                        } }) })));
            }
        }),
        loadCollectionMetadata: (contract, currencyId) => __awaiter(this, void 0, void 0, function* () {
            var _b;
            const key = (0, helpers_1.getNftCollectionKey)(contract, currencyId);
            const currency = (0, cryptoassets_1.getCryptoCurrencyById)(currencyId);
            const currencyBridge = (0, bridge_1.getCurrencyBridge)(currency);
            if (!((_b = currencyBridge === null || currencyBridge === void 0 ? void 0 : currencyBridge.nftResolvers) === null || _b === void 0 ? void 0 : _b.collectionMetadata)) {
                throw new Error("Currency doesn't support Collection Metadata");
            }
            setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: Object.assign(Object.assign({}, oldState.cache), { [key]: {
                        status: "loading",
                    } }) })));
            try {
                const { status, result } = yield currencyBridge.nftResolvers.collectionMetadata({
                    contract,
                    currencyId: currency.id,
                });
                switch (status) {
                    case 500:
                        throw new Error("NFT Metadata Provider failed");
                    case 404:
                        setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: Object.assign(Object.assign({}, oldState.cache), { [key]: {
                                    status: "nodata",
                                    metadata: null,
                                    updatedAt: Date.now(),
                                } }) })));
                        break;
                    case 200:
                        setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: Object.assign(Object.assign({}, oldState.cache), { [key]: {
                                    status: "loaded",
                                    metadata: result,
                                    updatedAt: Date.now(),
                                } }) })));
                        break;
                    default:
                        break;
                }
            }
            catch (_error) {
                // This shenanigan is here to avoid an Hermes bug https://github.com/pmndrs/zustand/discussions/1269
                const error = new Error(_error ? _error.message : "Unknown Error");
                setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: Object.assign(Object.assign({}, oldState.cache), { [key]: {
                            status: "error",
                            error,
                            updatedAt: Date.now(),
                        } }) })));
            }
        }),
        clearCache: () => {
            setState(oldState => (Object.assign(Object.assign({}, oldState), { cache: {} })));
        },
    }), []);
    const value = Object.assign(Object.assign({}, state), api);
    return react_1.default.createElement(NftMetadataContext.Provider, { value: value }, children);
}
exports.NftMetadataProvider = NftMetadataProvider;
//# sourceMappingURL=index.js.map